var Escrito = (function () {
    function Escrito() {
    }
    return Escrito;
}());
export { Escrito };
var EscritoPage = (function () {
    function EscritoPage(page, size, total, data) {
        this.page = page;
        this.size = size;
        this.total = total;
        this.data = data;
    }
    return EscritoPage;
}());
export { EscritoPage };
//# sourceMappingURL=escrito.js.map